<template>
	<div class="c-dashboard__wrap"
        :data-component-name="$options.name"
	>
		<div class="schedule">
			Clients
			<br>...toDo!
		</div>
	</div>
</template>

<script>

	export default {
		name: "Schedule",
		data(){
			return {
			}
		},
		methods: {
		},
		mounted(){
		},
        // apollo: {
		// }
	}
</script>
<style lang="scss" scoped>
	@import "@/scss/views/Dashboard.scss";
</style>

<style lang="scss">
	.schedule{
		background-color: white;
		height: 100%;
		display: flex;
		flex-direction: column;
		padding: 60px;
	}
</style>